import { mergeTemplate } from './base-template';

export const immobilienTemplate = mergeTemplate({
  name: 'Immobilien',
  icon: '🏠',
  settings: {
    primaryColor: '#0369a1',
    accentColor: '#38bdf8',
    fontStack: 'instrument',
    stylePreset: 'swiss',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Immobilien-Dienstleistungen',
      heroSubtitle: 'Kompetenz, Marktkenntnis und persönliche Betreuung',
      packages: [
        { name: 'Verkauf', price: 'Erfolgshonorar', description: 'Professionelle Vermarktung Ihrer Immobilie', features: 'Bewertung, Fotografie, Inserate, Besichtigungen, Verhandlung, Notariat', highlighted: false },
        { name: 'Vermietung', price: '1 Monatsmiete', description: 'Mietersuche und Vertragsabwicklung', features: 'Inserate, Mieterprüfung, Besichtigungen, Mietvertrag, Übergabe', highlighted: true },
        { name: 'Bewertung', price: 'ab CHF 800', description: 'Professionelle Immobilienbewertung', features: 'Marktanalyse, Vergleichswerte, Gutachten, Beratungsgespräch', highlighted: false },
      ],
      ctaTitle: 'Ihr nächster Schritt',
      ctaText: 'Ob Verkauf, Kauf oder Bewertung — sprechen Sie mit uns über Ihre Immobilie.',
      ctaButtonText: 'Unverbindliche Beratung',
    },
    pageMethoden: {
      heroTitle: 'Unser Vorgehen',
      heroSubtitle: 'Vom Erstgespräch bis zum Vertragsabschluss',
      introText: 'Immobilien sind Vertrauenssache. Wir begleiten Sie mit Expertise und Engagement durch den gesamten Prozess.',
      steps: [
        { title: 'Bewertung', description: 'Professionelle Marktanalyse und realistische Preiseinschätzung' },
        { title: 'Vermarktung', description: 'Hochwertige Präsentation auf allen relevanten Kanälen' },
        { title: 'Besichtigung', description: 'Qualifizierte Interessenten, persönliche Führungen' },
        { title: 'Abschluss', description: 'Verhandlung, Vertragsgestaltung, notarielle Beurkundung' },
      ],
      tools: [
        { name: 'Marktdaten', description: 'Aktuelle Transaktionsdaten und Vergleichswerte' },
        { name: '3D-Visualisierung', description: 'Virtuelle Rundgänge und Drohnenaufnahmen' },
        { name: 'CRM-System', description: 'Effiziente Käufer- und Mieterdatenbank' },
      ],
      philosophyTitle: 'Unser Immobilien-Ansatz',
      philosophyText: 'Jede Immobilie hat ihre Geschichte. Wir finden die richtigen Menschen dafür — mit Geduld, Können und Marktkenntnis.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Lokal verwurzelt, bestens vernetzt',
      introText: 'Mit über 20 Jahren Erfahrung im Schweizer Immobilienmarkt sind wir Ihr kompetenter Partner vor Ort.',
      timeline: [
        { year: '2002', text: 'Gründung des Immobilienbüros' },
        { year: '2012', text: 'Expansion in die ganze Region' },
        { year: '2021', text: 'Einführung digitaler Vermarktungstools' },
      ],
      values: [
        { title: 'Marktkenntnis', description: 'Wir kennen jede Nachbarschaft und jeden Quadratmeterpreis' },
        { title: 'Ehrlichkeit', description: 'Realistische Bewertungen statt leerer Versprechen' },
        { title: 'Netzwerk', description: 'Zugang zu Käufern, Mietern und Partnern in der gesamten Region' },
      ],
      certifications: 'SVIT-Mitglied, Eidg. Immobilien-Treuhänder',
    },
  },
  components: {
    header: {
      companyName: 'Immobilien Muster',
      logoText: 'IM',
      navItems: ['Objekte', 'Vorgehen', 'Team', 'Kontakt'],
      ctaText: 'Bewertung anfragen',
    },
    hero: {
      title: 'Immobilien – klar vermarktet',
      subtitle:
        'Bewertung, Verkauf, Verwaltung – mit Struktur und Transparenz.',
      primaryBtn: 'Bewertung anfragen',
      secondaryBtn: 'Angebote',
    },
    trust: {
      items: [
        { value: 'Transparent', label: 'Prozess' },
        { value: 'Marktkenntnis', label: 'Region' },
        { value: 'Sauber', label: 'Dokumente' },
        { value: 'Erreichbar', label: 'Kontakt' },
      ],
    },
    services: {
      title: 'Services',
      subtitle: '',
      items: [
        {
          icon: '📈',
          title: 'Bewertung',
          text: 'Marktgerechte Einschätzung und Positionierung.',
        },
        {
          icon: '📣',
          title: 'Vermarktung',
          text: 'Exposé, Besichtigungen, Verhandlung.',
        },
        {
          icon: '🗂️',
          title: 'Verwaltung',
          text: 'STWE/Mietverwaltung nach Vereinbarung.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Erfahrung und Marktkenntnis.',
      members: [
        {
          name: 'Thomas Muster',
          role: 'Geschäftsführer & Immobilien-Treuhänder',
          image: '',
          bio: 'Eidg. dipl. Immobilien-Treuhänder. Über 20 Jahre Erfahrung in Verkauf und Bewertung.',
        },
        {
          name: 'Claudia Meier',
          role: 'Vermarktung & Vermietung',
          image: '',
          bio: 'Spezialistin für Objektpräsentation, Inserate und Mieterbetreuung.',
        },
      ],
    },
    testimonials: {
      title: 'Kundenstimmen',
      items: [
        {
          quote: 'Professionelle Vermarktung und schneller Verkauf.',
          author: 'Verkäufer',
          role: 'Eigentumswohnung',
        },
        {
          quote: 'Realistische Bewertung und eine ehrliche Beratung. Genau was wir gesucht haben.',
          author: 'Familie Brunner',
          role: 'Eigenheimverkauf',
        },
        {
          quote: 'Innerhalb von drei Wochen den perfekten Mieter gefunden. Sehr effizient.',
          author: 'René P.',
          role: 'Vermieter',
        },
        {
          quote: 'Die 3D-Visualisierung hat den Unterschied gemacht. Sehr moderne Vermarktung.',
          author: 'Simone K.',
          role: 'Wohnungsverkäuferin',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Wie läuft eine Bewertung ab?',
          answer:
            'Datenaufnahme, Vergleichswerte, Begehung – danach eine strukturierte Einschätzung.',
        },
        {
          question: 'Was kostet die Vermarktung meiner Immobilie?',
          answer: 'Wir arbeiten beim Verkauf auf Erfolgsbasis — Sie zahlen nur bei erfolgreichem Abschluss. Genaue Konditionen besprechen wir gerne im persönlichen Gespräch.',
        },
        {
          question: 'Wie lange dauert ein Verkauf im Durchschnitt?',
          answer: 'Je nach Objekt und Marktlage dauert ein Verkauf in unserer Region typischerweise 2 bis 6 Monate. Dank unserer Interessenten-Datenbank geht es oft schneller.',
        },
      ],
    },
    cta: {
      title: 'Bewertung anfragen',
      subtitle: 'Unverbindlich und strukturiert.',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
    footer: {
      companyName: 'Immobilien Muster',
      tagline: 'Immobilien-Services in Ihrer Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
  },
});
